import {SET_PRICE_PRECENT, SET_RATE_PLAN, SET_SALES_ACTIVE} from "./constans";

let initialState = {
    initRatePlan: null
};


let newState = null;
const commissionCalendarReducers = (state = initialState, action) => {

    switch (action.type) {
        case SET_PRICE_PRECENT:
            return {...state, object: action.payload}

        case SET_RATE_PLAN:
            return {...state, initRatePlan: action.payload}

        case SET_SALES_ACTIVE:
            return {...state, object: {...state.object, ...action.payload}}

        default:
            return state;
    }
};


export default commissionCalendarReducers;